/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCurrencyEuro = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M15 1a10.96 10.96 0 0 1 7.57 3.02l.24.234-1.42 1.409A9.004 9.004 0 0 0 6.512 9h8.489v2H6.055a9.099 9.099 0 0 0 0 2H15v2H6.512a9.004 9.004 0 0 0 14.615 3.592l.222-.213 1.411 1.417A10.966 10.966 0 0 1 15 23c-5.035 0-9.28-3.382-10.586-7.999L1 15v-2h3.045a11.14 11.14 0 0 1 0-2H1V9h3.414C5.72 4.383 9.964 1 15 1z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgCurrencyEuro as CurrencyEuro };
